import { render } from "./Editor.vue?vue&type=template&id=714ad7cc&scoped=true&ts=true"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"

import "./Editor.vue?vue&type=style&index=0&id=714ad7cc&scoped=true&lang=css"
import "./Editor.vue?vue&type=style&index=1&id=714ad7cc&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714ad7cc"]])

export default __exports__